module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/felden_02-a9068f377daf5ddfad4652939543b1c5.jpg";